import React from "react";
import "./Features.css";
import Phone_icon from "../../assests/Frame 18 (2).png";
import People_icon from "../../assests/Frame 18 (1).png";
import Card_icon from "../../assests/Frame 18.png";
import Tool_icon from "../../assests/Frame 18 (7).png";
import Money_icon from "../../assests/Frame 18 (4).png";
import Coin_icon from "../../assests/Frame 18 (6).png";
import Hand_holding_phone from "../../assests/mockuuups-female-hand-holding-iphone.png";
import Dollar_icon from "../../assests/$-icon.png";
import Map from "../../assests/Component 2.png";
import BillPayment from "../../assests/bill_payment.jpg";
import VirtualCards from "../../assests/virtual_cards.png";
import AiImage from "../../assests/ai.jpg";
import PhoneMockup from "../PhoneMockup/PhoneMockup";


const aiItems = [
  { icon: Phone_icon, text: "Snap to send money instantly. Fast, simple, and stress-free." },
  { icon: Card_icon, text: "Send money anytime, anywhere. Fast, reliable, and secure." },
  { icon: People_icon, text: "Settle your bills without stress. Quick, easy, and hassle-free." },
];

const bizItems = [
  { icon: Money_icon, text: "Bulk Payments: Manage payroll and supplier payments effortlessly." },
  { icon: Card_icon, text: "Virtual Accounts: Unique accounts per customer or transaction." },
  { icon: Coin_icon, text: "API Integration: Plug our payment gateway into your apps." },
  { icon: Tool_icon, text: "Reconciliation Tools: Streamline your financial management." },
];

const waItems = [
  { icon: Card_icon,  label: "Transfer",     text: "Send money to any bank account just by chatting on WhatsApp — no app needed." },
  { icon: Phone_icon, label: "Bill Payment",  text: "Pay electricity, water, cable TV and more without leaving your chat." },
  { icon: People_icon,label: "Snap to Pay",  text: "Snap a photo of any bill or invoice and let Sendcheap handle the rest instantly." },
  { icon: Coin_icon,  label: "Sell Crypto",  text: "Convert your crypto to naira and receive funds straight to your wallet via WhatsApp." },
];

const Features = () => {
  return (
    <section className="features">
      {/* Header */}
      <div className="feat-header">
        <span className="feat-label">Features</span>
        <h2 className="feat-title">
          Built for people,<br />
          <span className="feat-accent">not banks.</span>
        </h2>
        <p className="feat-subtitle">
          Powerful tools for everyday users and growing businesses alike.
        </p>
      </div>

      {/* Row 1 — Smart AI Banking */}
      <div className="feat-row">
        <div className="feat-text">
          <span className="feat-tag">Smart AI Banking</span>
          <h3 className="feat-col-title">Your money, smarter.</h3>
          <div className="feat-list">
            {aiItems.map((f, i) => (
              <div className="feat-item" key={i}>
                <div className="feat-item-icon">
                  <img src={f.icon} alt="" />
                </div>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="feat-visual">
          <div className="feat-pm-wrap">
            {/* Floating card — top left */}
            <div className="feat-float-card feat-fc-tl">
              <div className="ffc-dot"></div>
              <div>
                <div className="ffc-name">Sent &#8358;20,000</div>
                <div className="ffc-sub">to John Doe</div>
              </div>
            </div>

            <PhoneMockup
              screenshot={BillPayment}
              alt="Bill payment screen"
              size="md"
              className="feat-pm"
            />

            {/* Floating card — bottom right */}
            <div className="feat-float-card feat-fc-br">
              <div className="ffc-big">&#8358;350,000</div>
              <div className="ffc-sub">Total Savings</div>
            </div>
          </div>
        </div>
      </div>

      {/* Row 2 — WhatsApp Banking */}
      <div className="feat-row feat-row-flip">
        <div className="feat-visual">
          <div className="feat-pm-wrap">
            <PhoneMockup
              screenshot={AiImage}
              alt="WhatsApp banking screen"
              size="md"
              className="feat-pm"
            />
          </div>
        </div>
        <div className="feat-text">
          <span className="feat-tag feat-tag-wa">WhatsApp Banking</span>
          <h3 className="feat-col-title">Bank on WhatsApp,<br />no app required.</h3>
          <div className="feat-list">
            {waItems.map((f, i) => (
              <div className="feat-item" key={i}>
                <div className="feat-item-icon feat-item-icon-wa">
                  <img src={f.icon} alt="" />
                </div>
                <div>
                  <div className="feat-item-label">{f.label}</div>
                  <p>{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Row 3 — For Businesses */}
      <div className="feat-row feat-row-flip">
        <div className="feat-visual feat-hand-col">
          <div className="feat-pm-wrap">
            <PhoneMockup
              screenshot={VirtualCards}
              alt="Virtual cards screen"
              size="md"
              className="feat-pm"
            />
          </div>
        </div>
        <div className="feat-text">
          <span className="feat-tag">For Businesses</span>
          <h3 className="feat-col-title">Scale without limits.</h3>
          <div className="feat-list">
            {bizItems.map((f, i) => (
              <div className="feat-item" key={i}>
                <div className="feat-item-icon">
                  <img src={f.icon} alt="" />
                </div>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA highlight */}
      <div className="feat-cta">
        <div className="feat-cta-left">
          <img src={Dollar_icon} alt="" className="feat-cta-icon" />
          <h3>Experience the Sendcheap difference today!</h3>
          <p>
            Tailored financial tools that simplify every transaction — personal or business.
          </p>
          <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
            <button className="feat-cta-btn">Get Started &rarr;</button>
          </a>
        </div>
        <div className="feat-cta-right">
          <img src={Map} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Features;
